
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { LoadingPlaceholder } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`LoadingPlaceholder`}</h1>
<p>{`Used to create a loading effect to the UI, and replace a boring spinner. For the best effect you should compose multiple of these to replicate the UI you're loading. The same effect is used on components with `}<inlineCode parentName="p">{`isPlaceholder`}</inlineCode>{`.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { LoadingPlaceholder } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<LoadingPlaceholder />`} component={LoadingPlaceholder} mdxType="Playground">
  <LoadingPlaceholder mdxType="LoadingPlaceholder" />
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;